import Api from '@/services'
export default class BaseService {
  constructor(model) {
    this.model = model;
  }
  getModel() {
    return this.model;
  }

  countDataQuery(params) {
    var stringParam = '', stringWhere = '', fields = '', aggregate = '';
    aggregate = '_aggregate';
    fields =  '{ aggregate{ count } }';
    stringParam = '($where_key: ' + this.model.tableName + '_bool_exp)';
    stringWhere = '(where: $where_key)';
    var query = `query get${this.model.tableName}List${stringParam} {
      ${this.model.tableName}${aggregate}${stringWhere}
      ${fields}
    }`;
    return this.callExecute(query, params);
  }

  getListQuery(params = null) {
    var stringParam = '', stringWhere = '', fields = '', aggregate = '', stringDistinct = '';
    if (params !== null && params['fields'] !== undefined && params['fields'] !== '') {
      fields = '{' + params['fields'] + '}';
    } else {
      let return_fields = this.getReturnFields();
      fields = return_fields.mainTable
    }
    if (params !== null && params['aggregate'] !== undefined && params['aggregate'] !== '') {
      aggregate = '_aggregate';
      fields = params['aggregate']
    }
    if (params !== null && params['distinct'] !== undefined && params['distinct'] !== '') {
      stringDistinct = 'distinct_on:' + params['distinct'] + ', ';
    }
    stringParam = '($where_key: ' + this.model.tableName + '_bool_exp, $orderBy: [' + this.model.tableName + '_order_by!], $offset: Int, $limit: Int)';
    stringWhere = '(' + stringDistinct + ' where: $where_key, order_by: $orderBy, offset: $offset, limit: $limit)';
    var queries = `query get${this.model.tableName}List${stringParam} { ${this.model.tableName}${aggregate}${stringWhere} ${fields} }`;
    return this.callExecute(queries, params);
  }
  updateDataQuery(params = null) {
    let return_fields = this.getReturnFields();
    var queries = `mutation update${this.model.tableName}($where_key: ${this.model.tableName}_bool_exp!, $data_update: ${this.model.tableName}_set_input) { update_${this.model.tableName}(where: $where_key, _set: $data_update) { affected_rows returning ${return_fields.mainTable} } }`;
    return this.callExecute(queries, params);
  }
  insertDataQuery(params = null) {
    var return_fields = this.getReturnFields();
    var queries = `mutation insert${this.model.tableName}($objects: [${this.model.tableName}_insert_input!]!) { insert_${this.model.tableName}(objects: $objects) { affected_rows returning ${return_fields.mainTable} } }`;
    return this.callExecute(queries, params);
  }
  deleteDataQuery(params = null) {
    var queries = `mutation delete${this.model.tableName}($where_key: ${this.model.tableName}_bool_exp!) { delete_${this.model.tableName}(where: $where_key) { affected_rows } }`;
    return this.callExecute(queries, params);
  }
  getReturnFields() {
    var return_fields = [
      "{",
      ...this.model.getFieldList(),
      ... this.model.getFieldListRelation(),
      "}"
    ].filter(function(e){return e}).join(" ");
    return { mainTable: return_fields};
  }
  async callExecute(queries, params) {
    // console.log('dddddddd', queries)
    var payload = { query: queries};
    if (params !== null && params['variables'] !== undefined && params['variables'] !== '') {
      payload = Object.assign(payload, {variables: params['variables']})
    }
    const results = await Api.post('/common/execute', payload);
    return results.data.data;
  }
}
